export interface ProviderInterface {
    id?: string;
    name?: string;
    cif?: string;
    iban?: string;
    socialReason?: string;
    purchaseDefault?: boolean;
    email?: string;
    phone?: string;
    address?: string;
    postalCode?: string;
    town?: string;
    state?: string;
}

export default class Provider implements ProviderInterface {
    public id?: string;
    public name?: string;
    public cif?: string;
    public iban?: string;
    public socialReason?: string;
    public purchaseDefault?: boolean;
    public email?: string;
    public phone?: string;
    public address?: string;
    public postalCode?: string;
    public town?: string;
    public state?: string;
}
